/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_SectionInputs */

const en_clients_field_address_section = /** @type {(inputs: Clients_Field_Address_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const pt_br2_clients_field_address_section = /** @type {(inputs: Clients_Field_Address_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Clients_Field_Address_SectionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_section = /** @type {((inputs?: Clients_Field_Address_SectionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_SectionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_section(inputs)
	return pt_br2_clients_field_address_section(inputs)
});